import { render, staticRenderFns } from "./SelectorGame.vue?vue&type=template&id=63c29312&scoped=true"
import script from "./SelectorGame.vue?vue&type=script&lang=js"
export * from "./SelectorGame.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorGame.vue?vue&type=style&index=2&id=63c29312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c29312",
  null
  
)

export default component.exports